import { memo, FC } from 'react';

import resets from '../../_resets.module.css';
import classes from './PageTitle.module.scss';

interface Props {
  className?: string;
  classes?: {
    root?: string;
  };
  title?:string;
  subTitle?:string;
}

export const PageTitle: FC<Props> = memo(function PageTitle(props) {
  return (
    <div className={classes.pageTitleWrap}>
      <h2 className={`${resets.clapyResets} ${props.classes?.root || ''} ${props.className || ''} ${classes.pageTitle}`}>{props.title || 'TITLE'}</h2>
      <div className={`${resets.clapyResets} ${props.classes?.root || ''} ${props.className || ''} ${classes.subTitle}`}>{props.subTitle || ''}</div>
    </div>
  );
});


